export default class BankAccountRequestField {

    constructor(jsonResponse) {
        this.id = jsonResponse["id"];
        this.bankAccountRequestId = jsonResponse["bank-account-request-id"];
        this.fieldKeyDisplayValue = jsonResponse["field-key-display-value"];
        this.fieldValue = jsonResponse["field-value"];
    }
}
